export const es = {
  HOME: '/',
  CONTENT: '/[...content]',
  NEWS_LISTING: '/noticia',
  NEWS_LISTING_BY_SLUG: '/noticia/listado/[newsListing]',
  NEWS_CATEGORY: '/noticia/categoria/[category]',
  NEWS_TAG: '/noticia/etiqueta/[tag]',
  ARTICLE: '/noticia/[article]',
  MATCH_CENTRE: '/partidos/[team]/[fixture]',
  FIXTURES: '/partidos/[team]/calendario',
  FIXTURES_COMPETITION: '/partidos/[team]/calendario/[competition]',
  RESULTS: '/partidos/[team]/resultados',
  RESULTS_COMPETITION: '/partidos/[team]/resultados/[competition]',
  RESULTS_COMPETITION_SEASON:
    '/partidos/[team]/resultados/[competition]/[season]',
  TABLE: '/partidos/[team]/clasificacion',
  TABLE_COMPETITION: '/partidos/[team]/clasificacion/[competition]',
  TABLE_COMPETITION_SEASON:
    '/partidos/[team]/clasificacion/[competition]/[season]',
  TEAM: '/equipos/[team]',
  PROFILE: '/equipos/[team]/[profile]',
  TEAM_YOUTH: '/equipos/juveniles/[team]',
  PROFILE_YOUTH: '/equipos/juveniles/[team]/[profile]',
  VIDEO_LANDING: '/video',
  VIDEO_DETAIL: '/video/[slug]',
  VIDEO_CATEGORY: '/video/categoria/[category]',
  VIDEO_PLAYLIST_LISTING: '/video/listas',
  VIDEO_PLAYLIST: '/video/listas/[slug]',
  VIDEO_COLLECTION: '/video/coleccion/[collection]',
} as const;
